var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.8333 36.6667H13.1667C11.4178 36.6667 10 38.0844 10 39.8333V40.1667C10 41.9156 11.4178 43.3333 13.1667 43.3333H66.8333C68.5822 43.3333 70 41.9156 70 40.1667V39.8333C70 38.0844 68.5822 36.6667 66.8333 36.6667Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8333 53.3333H13.1667C11.4178 53.3333 10 54.7511 10 56.5V56.8333C10 58.5822 11.4178 60 13.1667 60H66.8333C68.5822 60 70 58.5822 70 56.8333V56.5C70 54.7511 68.5822 53.3333 66.8333 53.3333Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8333 20H13.1667C11.4178 20 10 21.4178 10 23.1667V23.5C10 25.2489 11.4178 26.6667 13.1667 26.6667H66.8333C68.5822 26.6667 70 25.2489 70 23.5V23.1667C70 21.4178 68.5822 20 66.8333 20Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuOutline);
export default __webpack_public_path__ + "static/media/menu-outline.58a54330589bf504804b2546a376494a.svg";
export { ForwardRef as ReactComponent };